<template>
	<div v-if="currentEvent" class="container col-12 px-3 py-3">
		<div class="card mb-3">
			<div class="row g-0">
				<div class="col-md-4">
					<img :src="currentEvent.image" :alt="currentEvent.title" class="img-fluid rounded-start" />
				</div>
				<div class="col-md-8">
					<div class="card-body">
						<h5 class="card-title">{{ currentEvent.title }}</h5>
						<p class="card-text">
							Тип: <b>{{ currentEvent.typeText }}</b>
							<br />
							Проект: <b>{{ currentEvent.projectText }}</b> <br />
							Участников:
							<b
								>{{ partisipantsCount
								}}<span v-if="currentEvent.maxCompetitors > 0">/{{ currentEvent.maxCompetitors }}</span></b
							>
							<br />
							Начало: <b> {{ currentEvent.dateStart | moment("DD.MM.YYYY HH:mm") }} </b>
							<br />
							Конец: <b> {{ currentEvent.dateEnd | moment("DD.MM.YYYY HH:mm") }} </b>
							<br />
							Статус: <b>{{ currentEventEnded ? "Завершено" : "Завершится" }}</b>
							<br />
						</p>

						<div class="card-footer">
							<button type="button" class="btn btn-info mt-2 mt-md-0 ml-2" @click="showEvent()">На страницу</button>
							<button type="button" class="btn btn-primary mt-2 mt-md-0 ml-2" @click="editEvent()">Изменить</button>
							<template>
								<button
									@click="exportExcel()"
									class="btn btn-primary mt-2 mt-md-0 ml-2"
									:disabled="isLoadingExport || exportUrl"
								>
									<span v-show="isLoadingExport" class="spinner-border spinner-border-sm"></span> Сформировать Excel
								</button>

								<a :href="exportUrl" v-if="exportUrl">
									<button type="button" class="btn btn-success mt-2 mt-md-0 ml-2">Скачать</button>
								</a>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="userCanEdit && partisipantList.length">
			<h4>Список участников</h4>
			<div class="table-responsive">
				<table class="table table-bordered table-responsive-sm">
					<thead>
						<tr>
							<th>id</th>
							<th>Email</th>
							<th>Присоединился</th>
							<th class="text-center" colspan="10">Профиль</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(partisipant, index) in partisipantList" :key="index">
							<td>{{ partisipant._id }}</td>
							<td>{{ partisipant.user.email }}</td>
							<td>{{ partisipant.createdAt | moment("DD.MM.YYYY") }}</td>
							<td v-for="(field, idx) in partisipant.user.profile" :key="idx">
								{{ field }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import EventDataService from "../../services/event.service";
import ParticipantsDataService from "../../services/participants.service";
import moment from "moment";

export default {
	name: "event-details",

	metaInfo() {
		return {
			title: `Статистика по ${this.pageTitle}`,
			meta: [{ name: "description", content: this.pageDescription }],
		};
	},
	data() {
		return {
			currentEvent: {},
			//meta
			pageTitle: undefined,
			pageDescription: undefined,

			partisipantId: null,
			userParticipant: false,
			partisipantList: [],
			partisipantsCount: 0,
			errorMsg: "",
			errorRoute: null,
			successMsg: "",
			isLoadingExport: false,
			exportUrl: null,
		};
	},
	computed: {
		...mapGetters({
			getEventType: "params/GET_EVENT_TYPE",
			getProject: "params/GET_PROJECT",
		}),
		currentUser() {
			return this.$store.state.auth.user;
		},
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
		userCanEdit() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_ADMIN", "ROLE_MODERATOR");
			}
			return false;
		},
		currentEventEnded() {
			if (this.currentEvent.dateEnd === null) {
				//если нет даты завершения, сраниваем с окончанием дня
				return moment().diff(moment(this.currentEvent.dateStart).endOf("day"), "minutes") > 0;
			} else {
				return moment().diff(moment(this.currentEvent.dateEnd), "minutes") > 0;
			}
		},
	},
	methods: {
		async getEvent(id) {
			try {
				let eventResponse = await EventDataService.get(id);
				this.currentEvent = eventResponse.data;

				let typeParams = this.getEventType(this.currentEvent.type);
				if (typeParams) {
					this.currentEvent.joinText = typeParams.joinText;
					this.currentEvent.typeText = typeParams.name;
				}

				let projectParams = this.getProject(this.currentEvent.project);
				if (projectParams) {
					this.currentEvent.projectText = projectParams.name;
				}

				this.currentEvent.image = this.currentEvent.gridImage;

				this.pageTitle = this.currentEvent.title;
				this.pageDescription = this.currentEvent.description;
				if (!this.pageTitle) {
					this.pageTitle = undefined;
					this.pageDescription = undefined;
				}
				//get users count
				try {
					let eventParticipationsCount = await ParticipantsDataService.getEventParticipantsCount(this.currentEvent);
					this.partisipantsCount = eventParticipationsCount.data.length;
				} catch (err) {
					if (err.response.status === 404) {
						this.errorMsg = err.response.data.message;
					} else {
						this.errorMsg = err.response.data.message;
					}

					this.$refs.errModal.open();
				}
			} catch (err) {
				if ([404].includes(err.response.status)) {
					this.$router.push({ name: "404-page" });
				}
			}
		},
		editEvent() {
			this.$router.push({ name: "event-edit", params: { id: this.currentEvent._id } });
		},
		showEvent() {
			this.$router.push({ name: "event-details", params: { id: this.currentEvent.shortId } });
		},
		async exportExcel() {
			this.isLoadingExport = true;

			let res = await ParticipantsDataService.getEventParticipantsExcel(this.currentEvent);

			if (res.data.fileUrl) {
				this.exportUrl = res.data.fileUrl;

				if (this.exportUrl !== null) {
					this.isLoadingExport = false;
				}
			}
		},

		async getEventParticipantsList() {
			let event = this.currentEvent;
			let user = this.currentUser;

			if (this.loggedIn && user.id && event._id && user.roles.includes("ROLE_ADMIN")) {
				let eventParticipations = [];

				try {
					eventParticipations = await ParticipantsDataService.getEventParticipantsList(event);

					if (eventParticipations.data.length) {
						this.partisipantList = eventParticipations.data;
					}
				} catch (err) {
					if ([401, 403].includes(err.response.status)) {
						this.$store.commit("auth/LOGOUT");
						this.errorMsg = "Сессия истекла. Войдите в ваш личный кабинет";
					} else {
						this.errorMsg = err.response.data.message;
						this.errorRoute = err.response.data.route;
					}
					this.$refs.errModal.open();
				}
			}
		},
		goToRoute(route) {
			this.$router.push({ name: route });
		},
		closeModal() {
			this.$refs.okModal.close();
			this.$refs.errModal.close();
		},
	},
	async mounted() {
		await this.getEvent(this.$route.params.id);
		if (this.loggedIn && this.currentEvent && this.currentUser) {
			await this.getEventParticipantsList();
		}
	},
};
</script>

<style>
.content img {
	max-width: 100%;
	height: auto;
	width: auto;
	height: auto;
}

.content a {
	/* These are technically the same, but use both */
	overflow-wrap: break-word;
	word-wrap: break-word;

	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;

	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}
</style>
